import styled from "styled-components";

export const StyledTextarea = styled.textarea`
  width: 100%;
  height: 48px;
  color: ${({ theme }) => theme.colors.primary};
  border-radius: 8px;
  outline: none;
  padding-top: 0.889em !important;
`;
